export default __webpack_public_path__ + "static/media/regulatory--no-turn-on-red--g1.d126fe1a.png";